// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner___mYpj","errorLogs":"EditorFooter_errorLogs__2UltT"};